/* eslint-disable camelcase */
import PropTypes from "prop-types";
import { buttons as buttonThemes } from "theme/components/buttons/ThemeButton";

const buttonThemeKeys = Object.keys(buttonThemes);
export const buttonThemeProp = PropTypes.oneOf(buttonThemeKeys);

export const buttonProp = PropTypes.exact({
    label: PropTypes.string,
    link: PropTypes.string,
    buttonTheme: buttonThemeProp,
    button_theme: buttonThemeProp,
});

export const buttonsProp = PropTypes.oneOfType([PropTypes.bool, PropTypes.array]);
